import React from 'react';

import FilterListIcon from '@mui/icons-material/FilterList';
import {
    Box,
    Card,
    Grid,
    Tooltip,
    IconButton,
    Collapse,
} from '@sunwisesoftware/sunwise-ui';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
    AutocompleteField,
    AutocompleteMultipleField,
    InputSearch,
    ManageCsvDropdown,
    StatusFilterSelect,
} from 'common/components';

import {
    getSizeLgStatus,
    getAlliancesOptions,
    getUsersOptions2,
} from '../helpers';

const Filters = ({
    alliances,
    downloadFile,
    filterData,
    handleClickAlliance,
    handleClickStatus,
    handleClickUser,
    handleOnChangeSearch,
    handleOnSelectStatus,
    isFetchingAlliances,
    selectionModel,
    statusList,
    users,
}) => {
    const { t } = useTranslation();
    const [filterIsOpen, setFilterIsOpen] = React.useState(false);
    const toggleFilter = () => setFilterIsOpen((prev) => !prev);

    return (
        <Card>
            <Card.Body>
                <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                    <InputSearch
                        onChange={handleOnChangeSearch}
                        placeholder={t(
                            'Search by client, project, financial product',
                        )}
                        value={filterData?.searchText}
                    />
                    <Tooltip title={t('Filter', { count: 2 })}>
                        <IconButton onClick={toggleFilter}>
                            <FilterListIcon />
                        </IconButton>
                    </Tooltip>

                    <ManageCsvDropdown
                        handleDownload={() => downloadFile(filterData)}
                    />
                </Box>
                <Collapse in={filterIsOpen}>
                    <Grid container mt={2}>
                        <Grid size={{ lg: 3, md: 9, xs: 18 }}>
                            <StatusFilterSelect
                                filterBy={filterData?.status2}
                                handleSelected={handleOnSelectStatus}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid size={{ lg: 3, md: 9, xs: 18 }}>
                            <AutocompleteField
                                label={
                                    isEmpty(filterData?.financialAdvisor)
                                        ? t('All executives')
                                        : t('Executive')
                                }
                                onChange={handleClickUser}
                                options={getUsersOptions2(users)}
                                value={filterData?.financialAdvisor}
                            />
                        </Grid>
                        <Grid size={{ lg: 3, md: 18, xs: 18 }}>
                            <AutocompleteField
                                disabled={isFetchingAlliances}
                                label={
                                    isEmpty(filterData?.allianceId)
                                        ? t('All the companies')
                                        : t('Company')
                                }
                                onChange={handleClickAlliance}
                                options={getAlliancesOptions(alliances)}
                                value={filterData?.allianceId}
                            />
                        </Grid>
                        <Grid
                            size={{
                                lg: getSizeLgStatus(selectionModel),
                                xs: 18,
                            }}
                        >
                            <AutocompleteMultipleField
                                label={
                                    filterData?.status.length === 0
                                        ? t('All statuses')
                                        : t('Status')
                                }
                                onChange={handleClickStatus}
                                options={statusList}
                                value={filterData?.status}
                            />
                        </Grid>
                    </Grid>
                </Collapse>
            </Card.Body>
        </Card>
    );
};

Filters.propTypes = {
    alliances: PropTypes.any,
    downloadFile: PropTypes.func,
    filterData: PropTypes.object,
    handleClickAlliance: PropTypes.func,
    handleClickStatus: PropTypes.func,
    handleClickUser: PropTypes.func,
    handleOnChangeSearch: PropTypes.func,
    handleOnSelectStatus: PropTypes.func,
    isFetchingAlliances: PropTypes.bool,
    selectionModel: PropTypes.array,
    statusList: PropTypes.array,
    users: PropTypes.array,
};

export default Filters;
